import React, { useState } from "react";

const FailModal = ({ id, isFailModal, closeFailModal, handleProceedClick }) => {
  const [tryAgainClicked, setTryAgainClicked] = useState(false);

  const handleTryAgainButtonClick = () => {
    if (!tryAgainClicked) {
      // Close the current modal
      closeFailModal();
      setTryAgainClicked(true);
    }
  };

  return (
    <>
      <div
        id={id}
        className={`${
          isFailModal ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center min-h-[50%] w-full">
          <div className="relative bg-white shadow-lg rounded-md w-[90%] max-w-lg mx-auto">
            <div className="text-center">
              <div className="mt-4 mb-12 mx-auto items-center justify-center">
                <img src="/error_image.png" alt="Success" className="mx-auto" />
                <div className="text-[#000] text-[15px] font-normal mt-10">
                  <p>
                    We couldn't read the document or it might be invalid. Please
                    try
                  </p>
                  <p>again.</p>
                </div>
                <div className="flex items-center justify-center mt-10 space-x-4">
                  <button
                    onClick={handleTryAgainButtonClick}
                    data-modal-toggle={id}
                    type="button"
                    className={`${
                      tryAgainClicked
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-[#005C53] hover:bg-[#0086FF]"
                    } text-[#FFF] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center`}
                    disabled={tryAgainClicked}
                  >
                    Try Again
                  </button>
                  <button
                    onClick={handleProceedClick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-[#005C53] bg-[#FFF] border border-[#005C53] hover:bg-[#F0F0F0] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FailModal;
